import React from 'react';

import { formatDate } from 'Helpers/dateUtils';
import { formatFigure } from 'Helpers/formatService';

import TableRowSkeleton from 'CommonComponents/TableRowSkeleton';
import Tooltip from 'CommonComponents/Tooltip';

import ArrowUturnLeftIcon from 'Assets/icons/arrow-uturn-left.svg';
import TrashIcon from 'Assets/icons/trash.svg';

export default function TrashedGeneralOpportunitiesTable({ isLoading, opportunities, onRestore, onForceDelete }) {
    return (
        <div className="inbud-table_wrapper">
            <div className="tw-overflow-y-auto tw-max-h-[40vh]">
                <table className="inbud-table tw-table-fixed">
                    <thead>
                        <tr>
                            <th className="tw-sticky tw-top-0 tw-w-48">{$t('Department')}</th>
                            <th className="tw-sticky tw-top-0 tw-w-48">{$t('Name')}</th>
                            <th className="tw-sticky tw-top-0 tw-w-32">{$t('Amount')}</th>
                            <th className="tw-sticky tw-top-0 tw-w-48">{$t('Deleted By')}</th>
                            <th className="tw-sticky tw-top-0 tw-w-48">{$t('Deleted At')}</th>
                            <th className="tw-sticky tw-top-0 tw-w-32">{$t('Actions')}</th>
                        </tr>
                    </thead>
                    {!isLoading && !!opportunities?.length && (
                        <tbody>
                            {opportunities.map((opportunity) => (
                                <tr key={opportunity.id}>
                                    <td>{opportunity.department_name}</td>
                                    <td>{opportunity.name}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(opportunity.amount)}</td>
                                    <td>
                                        {opportunity.deleted_by_user
                                            ? `${opportunity.deleted_by_user.first_name} ${opportunity.deleted_by_user.last_name}`
                                            : '-'}
                                    </td>
                                    <td>{opportunity.deleted_at ? formatDate(opportunity.deleted_at) : '-'}</td>
                                    <td>
                                        <div className="tw-flex tw-items-center tw-gap-x-3">
                                            <Tooltip placement="top" tooltipContent={$t('Restore')} tooltipType="text">
                                                <button type="button" className="tw-text-green" onClick={() => onRestore(opportunity)}>
                                                    <ArrowUturnLeftIcon className="tw-w-3 tw-h-3" />
                                                </button>
                                            </Tooltip>
                                            <Tooltip placement="top" tooltipContent={$t('Permanently Delete')} tooltipType="text">
                                                <button type="button" className="tw-text-red" onClick={() => onForceDelete(opportunity)}>
                                                    <TrashIcon className="tw-w-3 tw-h-3" />
                                                </button>
                                            </Tooltip>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    )}
                    {isLoading && (
                        <tbody>
                            <TableRowSkeleton rows={3} columns={6} />
                        </tbody>
                    )}
                    {!isLoading && !opportunities?.length && (
                        <tbody>
                            <tr>
                                <td colSpan={6}>
                                    <span className="tw-italic">{$t('No deleted opportunities found')}</span>
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </div>
    );
}
